import React, { FC, useEffect } from 'react';
import { VStack } from '@chakra-ui/react';
import { useRecommendedItems } from '@olo-web/domain/recommendations/queries/useRecommendedItems';
import { ItemUpsellCarousel } from '@templates/Bag/ItemUpsell/ItemUpsellCarousel/ItemUpsellCarousel';
import { ItemUpsellCard, ItemUpsellCardSkeleton } from './ItemUpsellCard/ItemUpsellCard.ui';
import { useIsDineIn, useSendEvent } from '@olo-web/utils/common/hooks';
import { EAnalyticsEventNames } from '@olo-web/types/enums';
import { EGALocations } from '@olo-web/types/enums/googleAnalyticsLocations.enum';

export const ItemUpsell: FC = () => {
  const { data: recommendedItems, isLoading } = useRecommendedItems();
  const { sendEvent } = useSendEvent();
  const isDinein = useIsDineIn();
  const twoSkeletonCards = [0, 0].map((x, i) => <ItemUpsellCardSkeleton key={i} />);
  const itemCards = recommendedItems?.map((item) => <ItemUpsellCard item={item} key={item.id} />);

  useEffect(() => {
    if (isLoading) return;

    sendEvent(EAnalyticsEventNames.DEFAULT, {
      googleAnalytics: {
        location: isDinein ? EGALocations.DINE_IN : EGALocations.ONLINE_ORDER,
        action: 'view',
        object: EAnalyticsEventNames.SUGGEST_ITEMS,
        eventMetadata: {
          number_items_suggested: recommendedItems?.length,
          suggested_items: recommendedItems?.map((i, index) => ({
            itemId: i.menuItemLocationId,
            displayOrder: index + 1,
          })),
        },
      },
    });
  }, [isDinein, recommendedItems, sendEvent, isLoading]);
  if (!isLoading && !recommendedItems?.length) return null;

  return (
    <VStack
      w="100%"
      px={{ base: 0 }}
      bg={{ base: 'transparent', md: 'white' }}
      mt={{ base: 0, md: -5 }}
      mb={{ base: 6, md: 0 }}
      width={{ base: '100%', md: 'calc(100% + 32px)' }}
    >
      <ItemUpsellCarousel gap={16} isLoading={isLoading}>
        {isLoading ? twoSkeletonCards : itemCards}
      </ItemUpsellCarousel>
    </VStack>
  );
};
